export const GAWidgetTexts = {
    title: "activation.home.GA.title",
    subtitle: "activation.home.GA.not.activated.subtitle",
    uniqueUsersPlaceholder: "activation.gawidget.uniqueUsers.placeholder",
    distributionDesktop: "activation.gawidget.distribution.desktop",
    distributionMobile: "activation.gawidget.distribution.mobileWeb",
    activateFirstPartyData: "activation.gawidget.activate.first.party.data",
    wow: "common.wow",
    mom: "common.mom",
    ownerNotConnectedData: "activation.home.GA.owner.not.connected.data",
    goToBenchmark: "activation.home.GA.benchmark.button",
};

export const ActivationModalTexts = {
    header: "activation.home.activation.data.modal.header",
    subtitle: "activation.home.activation.data.modal.subtitle",
    select: "common.select",
    GATitle: "Google Analytics",
    SWTitle: "Similarweb",
    GADescription: "activation.home.activation.data.modal.GADescription",
    SWDescription: "activation.home.activation.data.modal.SWDescription",
};
